// GraphQL fragments for booking-related queries
import { TIMESTAMP_FRAGMENT } from './common';

// Booking shop avatar fragment
export const BOOKING_SHOP_AVATAR_FRAGMENT = `
  url
  alt
`;

// Booking day of week fragment
export const BOOKING_DAY_OF_WEEK_FRAGMENT = `
  dayOfWeek
  startTime
  endTime
  timeGap
  bookingNumberLimit
`;

// Shop fragment for booking
export const BOOKING_SHOP_FRAGMENT = `
  id
  name
  displayedAddress
  avatar {
    ${BOOKING_SHOP_AVATAR_FRAGMENT}
  }
  bookingDayOfWeek {
    ${BOOKING_DAY_OF_WEEK_FRAGMENT}
  }
`;

// User fragment for booking
export const BOOKING_USER_FRAGMENT = `
  id
  name
`;

// Service fragment
export const SERVICE_FRAGMENT = `
  id
  name
  menuPrice
`;

// Voucher fragment
export const VOUCHER_FRAGMENT = `
  id
  code
`;

// Campaign package fragment
export const CAMPAIGN_PACKAGE_FRAGMENT = `
  id
  displayName
  type
`;

// Service transaction fragment
export const SERVICE_TRANSACTION_FRAGMENT = `
  quantity
  originalPrice
  discount
  finalPrice
  voucher {
    ${VOUCHER_FRAGMENT}
  }
  service {
    ${SERVICE_FRAGMENT}
  }
  campaignPackage {
    ${CAMPAIGN_PACKAGE_FRAGMENT}
  }
`;

// Main booking fragment
export const BOOKING_FRAGMENT = `
  id
  customerNumber
  bookingDate
  startTime
  status
  note
  phone
  populatedUser {
    ${BOOKING_USER_FRAGMENT}
  }
  shop {
    ${BOOKING_SHOP_FRAGMENT}
  }
  serviceTransaction {
    ${SERVICE_TRANSACTION_FRAGMENT}
  }
  totalOriginalPrice
  totalDiscount
  totalFinalPrice
  ${TIMESTAMP_FRAGMENT}
`;

// Constants (not fragments, but related configuration)
export const BOOKING_IN_SHOP_SELECTION = [
  { value: "ARRIVE", label: "Arrive at shop" },
  { value: "ARRIVED", label: "Customer already arrived" },
];